import DomainsInput from './DomainsInput'

export default DomainsInput
